import React, { useEffect, useState } from "react";
import { Notification, useToaster } from 'rsuite';
import "rsuite/dist/rsuite.css";
import CustomLoader from "../../comman/Loader/CustomLoader"
import {  useParams } from "react-router-dom";
import { APIRequest, ApiUrl } from "../../../Helpers/ApiHelper";
import Header from "../../comman/Header-copy";
import Topbar from "../../comman/Topbar";
import List from './List';
import DetailsModal from "./DetailModal";
import Footer from "../../comman/Footer";




const TaskRequests = () => {

  const [taskRequests, setTaskRequests] = useState([]);
  const [reajectReason, setReajectReason] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [selectedTaskRequest, setSelectedTaskRequest] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const toaster = useToaster();
  const { id } = useParams();

  useEffect(() => {
 
    if (id !== undefined) {
      getCampaignTasks(id)
      
    }
    const close = (e) => {
      if (e.keyCode === 27) {
        setShowModal(false);
      }
    }
    window.addEventListener('keydown', close)
    return () => window.removeEventListener('keydown', close)
  }, []);

  const getCampaignTasks = (id) => {
    let confing = {
      url: `${ApiUrl.getCampaignTasks}/${id}`,
      method: 'GET',
      body: {}
    }

    APIRequest(
      confing,
      res => {
        setIsLoading(false);
        setShowModal(!showModal);
        setTaskRequests(res?.campaign);
      },
      err => {
        setIsLoading(false);
      }
    )
  }


  const updateTaskStatus = (action) => {
    setIsLoading(true);
    let config = {
      url: ApiUrl.updateCampaignTaskRequest,
      method: 'POST',
      body: {
        campaignTaskRequest: selectedTaskRequest?.id,
        reajectReason: reajectReason,
        status: action,
      }
    }
    APIRequest(
      config,
      res => {
        setIsLoading(false);
        toaster.push(<Notification type='success' header="Success"  >{res.message}</Notification>, {
          placement: 'topEnd'
        });
        getCampaignTasks(id);
      },

      err => {
        setIsLoading(false);
        alert('SERVER ERROR');
      }

    )
  }

  const handleRejectReason = (e) => {
    const { name, value } = e.target;
    setReajectReason({
      ...reajectReason,
      [name]: value
    })
  }

  const fetchPostData = (postId) => {
    let confing = {
      url: ApiUrl.brandFetchPostTrackingData + '/' + postId,
      method: 'GET',
      body: {}
    }

    APIRequest(
      confing,
      res => {
        setIsLoading(false);
        window.location.reload();
        // setMyPosts(res?.data);
        // getMyPosts();
      },

      err => {
        setIsLoading(false);
        toaster.push(<Notification type='warning' header="Warning"  >{err?.response?.data?.message} </Notification>, {
          placement: 'topEnd'
        });
      }

    )
  }

  return (
    <>
     <div className="min-h-[100vh]">
      <Header />
      <Topbar />
      <CustomLoader visible={isLoading} />
      <div className="container mx-auto mt-10 sm:mt-0">
        <div className="md:grid  md:gap-6">
          {!isLoading && (
            <div>

              <List data={taskRequests?.taskRequests} campaignInfo={taskRequests} onSelectTaskRequest={(item) => { setSelectedTaskRequest(item); setShowModal(true) }} />
              {selectedTaskRequest && (
                <DetailsModal
                  item={selectedTaskRequest}
                  showModal={showModal}
                  setShowModal={() => { setShowModal(!showModal); getCampaignTasks(id); }}
                  handleRejectReasonChange={(e) => handleRejectReason(e)}
                  onHandleClick={(action) => updateTaskStatus(action)}
                  trackPost={(postId) => fetchPostData(postId)}
                />
              )}

            </div>
          )}
        </div>



      </div>
      </div>

      <Footer colorClass="footerColor" clas="footer2" />


    </>
  );
};

export default TaskRequests;
